import { useEffect } from 'react'
import type { CSSProperties } from 'react'
import { UNLOCK_MS, duration, wait } from './timing'

/**
 * Plays once, immediately after a code is accepted, then hands control back.
 *
 * It owns the decision about when it is finished, so the invite view never
 * appears mid-animation. Under reduced motion the wait collapses to nothing and
 * `onDone` fires straight away.
 */
export function UnlockCurtain({ onDone }: { onDone: () => void }) {
  useEffect(() => {
    let cancelled = false
    void (async () => {
      await wait(duration(UNLOCK_MS))
      if (!cancelled) onDone()
    })()
    return () => {
      cancelled = true
    }
  }, [onDone])

  return (
    <div
      className="bg-cream fixed inset-0 z-50 flex items-center justify-center"
      role="status"
      aria-label="Opening your invitation"
    >
      <div
        className="animate-seal-break"
        style={{ '--unlock-duration': `${UNLOCK_MS}ms` } as CSSProperties}
      >
        <svg viewBox="0 0 100 100" className="h-32 w-32" aria-hidden="true">
          <circle cx="50" cy="50" r="42" fill="#9d4b52" />
          <circle cx="50" cy="50" r="32" fill="none" stroke="#c07278" strokeWidth="3" />
          <path
            d="M36 52 L47 63 L66 40"
            fill="none"
            stroke="#fdfaf3"
            strokeWidth="6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    </div>
  )
}
